export default {
      id: "btn-shape--blue-usage",
      viewBox: "0 0 55 54",
      url: "../../assets/" + "sprite.svg#btn-shape--blue-usage",
      toString: function () {
        return this.url;
      }
    }